function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "subscribe-1");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "subscribe-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.5,59h-38A10.51,10.51,0,0,1,0,48.5v-18A10.51,10.51,0,0,1,10.5,20h38A10.51,10.51,0,0,1,59,30.5v18A10.51,10.51,0,0,1,48.5,59Zm-38-34A5.51,5.51,0,0,0,5,30.5v18A5.51,5.51,0,0,0,10.5,54h38A5.51,5.51,0,0,0,54,48.5v-18A5.51,5.51,0,0,0,48.5,25Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.5,15H9.5a2.5,2.5,0,0,1,0-5h40a2.5,2.5,0,0,1,0,5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.5,5h-32a2.5,2.5,0,0,1,0-5h32a2.5,2.5,0,0,1,0,5Z"
}))));

var SvgSubscriptions = function SvgSubscriptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 59",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubscriptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subscriptions.45f076fe.svg";
export { ForwardRef as ReactComponent };